import Vue from 'vue';
import jsona from '@/lib/jsona';
import flatten from 'lodash/flatten';
import { DEFAULT_FILTRATION_VALUE } from '@/components/shared/visnet-hubs-common-consts';
import generateElectricalData from '@/utils/store/phasesFeedersHelpers';
import RootStateCommit from '@/store/mixins/rootstate-commit';
import VisnetHubElectricalData from '@/resources/visnet-hub-electrical-data';

const MODULE_NAME = 'electricalData';
const DEFAULT_FILTER = ['voltageMax', 'voltageMin'];

const DEFAULT_STATE = {
  data: new Map(),
  filtration: [DEFAULT_FILTRATION_VALUE.ELECTRICAL],
  selectedPhaseFeeder: null
};

export default {
  /* eslint no-param-reassign: ["error", { "props": false }] */
  namespaced: true,
  state: Object.assign(DEFAULT_STATE, {}),
  mutations: {
    parseResponseData(state, response) {
      const responseParsed = jsona.deserialize(response);
      const dataToPass = {
        selected: state.selectedPhaseFeeder,
        data: responseParsed,
        chartType: 'electrical'
      };
      const result = generateElectricalData({
        ...dataToPass,
        attributesToFilter: DEFAULT_FILTER
      });

      Vue.set(state, 'data', result);
    },
    setError(state, error) {
      state.error = error;
    },
    setPhaseFeeder(state, phaseFeeder) {
      state.selectedPhaseFeeder = phaseFeeder;
    },
    resetElectricalSeries(state) {
      state.data = new Map();
    },
    resetStore(state) {
      Object.assign(state, DEFAULT_STATE);
    },
    setActiveFiltration(state, filtration) {
      state.filtration = filtration;
    }
  },
  actions: {
    async fetchElectricalData({ commit }, visnetParams) {
      RootStateCommit(commit, 'startLoading', MODULE_NAME);

      commit('setError', null);

      const {
        externalVisnetHubId,
        projectCode,
        substationCode,
        startDate,
        endDate,
        basicInfoOnly,
        phase,
        feeder
      } = visnetParams;

      try {
        const response = await VisnetHubElectricalData({ externalVisnetHubId }).get({
          project_code: projectCode,
          substation_code: substationCode,
          start_date: startDate,
          end_date: endDate,
          basic_info_only: basicInfoOnly,
          phase_number: phase,
          feeder_number: feeder,
          include: 'phases,phases.feeders'
        });

        if (!response) throw Error;

        commit('parseResponseData', response.data);

        RootStateCommit(commit, 'stopLoading', MODULE_NAME);
        return response.ok;
      } catch (error) {
        commit('setError', error);

        RootStateCommit(commit, 'setResponseError', MODULE_NAME);
        RootStateCommit(commit, 'stopLoading', MODULE_NAME);

        return error.ok;
      }
    }
  },
  getters: {
    electricalAttributes: state => (state.data.size ? [...state.data.keys()] : []),
    filteredElectricalData: state => {
      const filteredAttributes = flatten(
        state.filtration.map(attribute => state.data.get(attribute) || false)
      );

      return filteredAttributes.filter(serie => serie);
    }
  }
};
